module.exports = __webpack_public_path__ + "static/media/NHSLondon.1f13e7a5.png";